import { useEffect, useState } from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { nanoid } from "@reduxjs/toolkit";
import { Box, Button, getColor, Icons, Modal, Typography, useToast } from "fds";
import useAppStore from "../../redux/dispatcher/useAppStore";
import useMeetingStore from "../../redux/dispatcher/useMeetingStore";
import type { PRODUCT_ITEM_TYPE } from "../../redux/api/appApi";
import AppRegisterModal from "../AppRegisterModal";

interface LinkAppProps {
  open: boolean;
  onClose: () => void;
  changeTargetOpenAppLinkPortal: (app: PRODUCT_ITEM_TYPE | undefined) => void;
}
const LinkApp: React.FC<LinkAppProps> = ({
  open,
  onClose,
  changeTargetOpenAppLinkPortal,
}) => {
  const toasts = useToast();
  const { t } = useTranslation();
  type PRODUCT_ITEM_TYPE = "zoom" | "googleDrive" | "dropbox";
  const PRODUCT_NAME = {
    zoom: "Zoom",
    // outlook: 'Outlook',
    googleDrive: "Google Drive",
    dropbox: "Dropbox",
  } as { [key in PRODUCT_ITEM_TYPE]: string };
  const INIT_OUTLOOK_INFO = {
    email: "",
    password: "",
    host: "",
    port: "",
    sslEnabled: false,
  };

  const { appState, getAppLoginInfo } = useAppStore();

  const [connectStatus, changeConnectStatus] = useState({
    zoom: false,
    outlook: false,
    googleDrive: false,
    dropbox: false,
  });
  const [openLinkAppModal, toggleOpenLinkAppModal] = useState("CLOSE"); // 연동, 연동해제 모달

  useEffect(() => {
    if (window.eco.companyName !== "linkApp" || !getAppLoginInfo) return;

    // getAppLoginInfo('googleDrive');
    getAppLoginInfo("dropbox");
  }, []);
  useEffect(() => {
    changeConnectStatus({
      ...connectStatus,
      googleDrive:
        !!appState.appRegisterStatus &&
        !!appState.appRegisterStatus.googleDrive,
      dropbox:
        !!appState.appRegisterStatus && !!appState.appRegisterStatus.dropbox,
    });
  }, [appState.appRegisterStatus]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      width={564}
      height={462}
      title={t("account.app.title")}
      footer={<Box height={33} />}
      body={
        <Box direction="column" width={"100%"}>
          {openLinkAppModal !== "CLOSE" && (
            <AppRegisterModal
              open={openLinkAppModal !== "CLOSE"}
              onClose={() => toggleOpenLinkAppModal("CLOSE")}
              handleAfter={() => toggleOpenLinkAppModal("CLOSE")}
              modalType={
                openLinkAppModal.includes("open") ? "CONNECT" : "UNCONNECT"
              }
              openLinkAppModal={openLinkAppModal}
            />
          )}
          <Typography type="subtitle2" classes="mg mt-14">
            {t("account.app.connectApp")}
          </Typography>
          <Typography
            classes="mg mt-12"
            type="caption_rg"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("account.app.info")}
          </Typography>
          <Box classes="mg mt-14" width={"100%"} direction="column">
            {(["dropbox"] as const).map((item: "googleDrive" | "dropbox") => {
              const isConnected = connectStatus[item as PRODUCT_ITEM_TYPE];
              return (
                <Box alignItems="center" classes="mg mt-20" width={"100%"}>
                  <img
                    src={require(`../../shared/images/common/dropbox.png`)}
                    alt="zoom"
                    width={"40px"}
                    height={"40px"}
                  />
                  <Typography type="subtitle2" classes="mg ml-12">
                    {PRODUCT_NAME[item]}
                  </Typography>
                  <Button
                    label={
                      isConnected
                        ? t("account.app.remove")
                        : t("account.app.connet")
                    }
                    type={isConnected ? "error" : "primary"}
                    btnStyle="link"
                    leadingIcon={
                      <Icons
                        variant="line"
                        label={isConnected ? "exceptionCircle" : "plusCircle"}
                      />
                    }
                    onClick={() =>
                      toggleOpenLinkAppModal(
                        isConnected ? "close_dropbox" : "open_dropbox"
                      )
                    }
                    classes="mg ml-auto"
                  />
                </Box>
              );
            })}
          </Box>
        </Box>
      }
    />
  );
};

export default LinkApp;
